import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import TableStyle from '../../ui-component/TableStyle';
import { useState } from 'react';
import { Stack, Button, Container, Typography, Box, Card } from '@mui/material';
import * as React from 'react';
import { useEffect } from 'react';
import { getApi } from 'views/services/api';
import { useNavigate } from 'react-router';

const OneYearReport = () => {
  const navigate = useNavigate();
  const [hotelData, setHotelData] = useState([]);

  // function for fetching all the hotels data from the db

  const fetchhotelData = async () => {
    try {
      console.log('api hit ==>', `api/hotel/viewallhotelreports`);
      const response = await getApi(`api/hotel/viewallhotelreports`);
      console.log('response --------- ===>', response);

      if (response.status === 204) {
        setHotelData([]);
      } else {
        setHotelData(response?.data);
      }
    } catch (error) {
      console.log('error ===>', error);
    }
  };
  useEffect(() => {
    fetchhotelData();
  }, []);

  const columns = [
    {
      field: 'name',
      headerName: 'Hotel Name',
      flex: 1,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        return (
          <Box
            onClick={() => {
              navigate(`/dashboard/hotel/view/${params.row._id}`);
            }}
          >
            {params.value}
          </Box>
        );
      }
    },

    {
      field: 'totalIncome1Year',
      headerName: 'Total Income',
      flex: 1,
      renderCell: (params) => {
        return <Box>Rs {params.value}</Box>;
      }
    },
    {
      field: 'roomCount',
      headerName: 'Total Rooms',
      flex: 1
    },
    {
      field: 'customerCount',
      headerName: 'Total Customer',
      flex: 1
    },
    {
      field: 'planName',
      headerName: 'Subscripion Plan',
      flex: 1
    },
    {
      field: 'days',
      headerName: 'End Date',
      flex: 1,
      valueGetter: (params) => {
        try {
          // Access the first item in the subscriptionInfo array
          const subscription = params.row.subscriptionInfo[0];

          if (!subscription) {
            throw new Error('Subscription info is missing');
          }

          // Extract and validate the startDate
          const startDateStr = subscription.createdDate;
          const startDate = new Date(startDateStr);

          if (isNaN(startDate.getTime())) {
            throw new Error('Invalid start date');
          }

          // Extract and validate the days
          const days = Array.isArray(subscription.days) ? parseInt(subscription.days[0], 10) : parseInt(subscription.days, 10);

          if (isNaN(days)) {
            throw new Error('Invalid number of days');
          }

          // Calculate the end date
          const endDate = new Date(startDate.getTime() + days * 24 * 60 * 60 * 1000);
          const dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
          return endDate.toLocaleString(undefined, dateOptions);
        } catch (error) {
        //   console.error('Error calculating end date:', error);
          return 'Invalid Date';
        }
      }
    },
    {
      field: 'planStatus',
      headerName: 'Plan Status',
      flex: 1,
      renderCell: (params) => {
        let color;
        switch (params.value) {
          case 'active':
            color = 'success';
            break;
          case 'expired':
            color = 'error';
            break;
          case 'expiresSoon':
            color = 'warning';
            break;
          default:
            color = 'inherit';
            break;
        }
        return (
          <Button variant="contained" color={color} sx={{ cursor: 'none' }}>
            {params.value}
          </Button>
        );
      }
    }
  ];

  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" my={2} justifyContent={'space-between'}>
          <Typography variant="h4">Past One Year Reports</Typography>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              {hotelData && <DataGrid rows={hotelData} columns={columns} getRowId={(row) => row?._id} />}
            </Card>
          </Box>
        </TableStyle>
      </Container>
    </>
  );
};

export default OneYearReport;
